import clsx from 'clsx'
import { LayoutGrid, PersonStanding, Radio, TrendingUp, Package } from 'lucide-react'

const iconMap = {
  'Home': LayoutGrid,
  'Calendar': PersonStanding,
  'Map': Radio,
  'TrendingUp': TrendingUp,
  'Package': Package,
}

const TabNavigation = ({ tabs, activeTab, onTabChange }) => {
  return (
    <div className="flex items-center justify-between">
      <div className="flex items-center space-x-1 bg-white p-1 rounded-lg border border-gray-200">
        {tabs.map((tab) => {
          const isActive = activeTab === tab.id
          const Icon = iconMap[tab.icon]
          // Extract label without emoji
          const labelText = tab.label.replace(/^[^\s]+\s/, '')
          
          return (
            <button
              key={tab.id}
              onClick={() => onTabChange(tab.id)}
              className={clsx(
                'flex items-center px-4 py-2 text-sm font-medium rounded-md transition-all duration-150',
                isActive
                  ? 'bg-blue-600 text-white shadow-sm'
                  : 'text-gray-600 hover:bg-gray-100'
              )}
            >
              {Icon && <Icon className="h-4 w-4 mr-2" />}
              <span>{labelText}</span>
            </button>
          )
        })}
      </div>
    </div>
  )
}

export default TabNavigation
